
import { useEffect, useRef } from 'react';

interface TikTokEmbedProps {
  videoId: string;
  className?: string;
}

export default function TikTokEmbed({ videoId, className = '' }: TikTokEmbedProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const loadScript = () => {
      const existingScript = document.querySelector('script[src="https://www.tiktok.com/embed.js"]');
      if (existingScript) {
        existingScript.remove();
      }
      const script = document.createElement('script');
      script.src = 'https://www.tiktok.com/embed.js';
      script.async = true;
      document.body.appendChild(script);
    };

    const timer = setTimeout(loadScript, 100);
    return () => clearTimeout(timer);
  }, [videoId]);

  return (
    <div ref={containerRef} className={className}>
      <blockquote
        className="tiktok-embed"
        cite={`https://www.tiktok.com/@user/video/${videoId}`}
        data-video-id={videoId}
        style={{ maxWidth: '100%' }}
      >
        <section></section>
      </blockquote>
    </div>
  );
}
